import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=2fec19d5"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports